/**
 * WhatsApp wa.me link. CRA inlines REACT_APP_* at build time — if unset on Vercel, the button was hidden.
 * Override with REACT_APP_WHATSAPP_PHONE (digits or +63…) when the number changes.
 */
const raw =
  process.env.REACT_APP_WHATSAPP_PHONE || '639468328005';
const digits = raw.replace(/\D/g, '');

const defaultMessage = "Hi Johnedel, I'd like to book a call.";

export const whatsappBookCallUrl = digits
  ? `https://wa.me/${digits}?text=${encodeURIComponent(defaultMessage)}`
  : null;
